import type { ReactNode } from "react";

export function EmptyState({
  title,
  children,
  actions,
}: {
  title?: string;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="empty-state">
      {title ? <h2>{title}</h2> : null}
      {children ? <p>{children}</p> : null}
      {actions ? <div className="empty-state__actions">{actions}</div> : null}
    </div>
  );
}
